import { RootState } from "../store";

export const AuthSelector = (state: RootState) => state.auth;
